import { appConstants } from "../constants";

const initialState = {};
export function parametersWidgets(state = initialState, action) {
  switch (action.type) {
    case appConstants.PARAMETER_WIDGET_SUCCESS: {
      return {
        ...state,
        ...action.params
      };
    }
    case appConstants.PARAMETER_WIDGET_FAILURE:
      return state;
    default:
      return state;
  }
}

const browserName = "";
export function browserDetect(state = browserName, action) {
  switch (action.type) {
    case appConstants.BROWSER_DETECT: {
      return {
        ...state,
        browserName: action.browserName
      };
    }
    default:
      return state;
  }
}

export function accountId(state = "", action) {
  switch (action.type) {
    case appConstants.BALANCE_VIEW_SUCCESS: {
      return {
        ...state,
        accountId: action.connection,
        mobileNo: action.mobileNo,
        emailId:action.emailId
      };
    }
    case appConstants.BALANCE_VIEW_FAILURE:
      return state;
    default:
      return state;
  }
}

const snackbarparam = "";
export function snackbar(state = snackbarparam, action) {
  switch (action.type) {
    case appConstants.SNACKBAR_SUCCESS:
      return {
        ...state,
        ...action
      };
    default:
      return state;
  }
}

const initialStateAppLogo = {};
export function appLogo(state = initialStateAppLogo, action) {
  switch (action.type) {
    case appConstants.APPLOGO_SUCCESS: {
      return {
        ...state,
        ...action.logoResponse
      };
    }
    case appConstants.APPLOGO_FAILURE:
      return state;
    default:
      return state;
  }
}

const initialStates = {};
export function userProfile(state = initialStates, action) {
  switch (action.type) {
    case appConstants.UPDATE_USER_PROFILE:
      return {
        ...state,
        firstName: action.firstName,
        lastName: action.lastname,
        accountNumber: action.accountNumber,
        registeredEmail: action.registeredEmail,
        registeredCell: action.registeredCell,
        password: action.password,
        confirmPassword: action.confirmPassword,
      };
    default:
      return state;
  }
}